<template>
  <div class="container-fluid page-container">
    <b-row class="vh-70">
      <b-col class="col-sm-7 m-auto">
        <b-card :body-class="['shadow', 'border', 'rounded', 'py-5', 'text-center']">
          <spinner v-if="busy" />
          <b-card-text v-else-if="isValidToken">
            <h2 class="mb-0 h3">
              Thank you, Your email has now been validated.
            </h2>
            <hr class="w-50">
            <router-link :class="'text-link text-link-reset'" :to="{name: 'dashboard'}">
              Return to dashboard
            </router-link>
          </b-card-text>
          <b-card-text v-else>
            <h2 class="text-danger h3 mb-0">
              This link is invalid
            </h2>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Spinner from '@/components/animation/Spinner';

export default {
  name: "ValidateEmail",
  components: {Spinner},
  data() {
    return {
      isValidToken: null,
      busy: true,
    }
  },
  created: function () {
    this.$api.verification.validateToken(this.$route.query.s).then(() => {
      this.isValidToken = true;
      this.$store.dispatch('checkState');
      this.busy = false;
    }).catch(() => {
      this.isValidToken = false;
      this.busy = false;
    });
  },
}
</script>

<style scoped>

</style>
